export const sdkURL = (url = "") =>
  new URL(url, "https://sdk-one-uat.carenow.healthcare");
export const api_key = "CNCPG9TPNw5V9FTDqFPg";
export const secret_key = "PulflyPw5IRTRhb2y8AoLdQFbbAKwDt6dh9HKX0v";
export const authEmployeeID = "internal-test";

export const allowedClentCodes = [
  "CPXINT",
  "SUNPH",
  "CPJIO",
  "CPBONV",
  "VITLYST",
  "ABWLNS",
  "WELCU",
];

export const rangeDetails = {
  "Lung Health Score": {
    info: "The Lung Health Score is a comprehensive metric designed to evaluate the overall health and functionality of your respiratory system. By analyzing various parameters such as cough sound patterns, heart rate, respiration rate, and other vital signs, this score provides a detailed insight into your pulmonary health.\nThis assessment helps in early detection of potential respiratory issues, enabling timely intervention and treatment. It leverages advanced artificial intelligence (AI) and machine learning (ML) algorithms to offer an accurate and reliable evaluation, making it an essential tool for both healthcare professionals and individuals monitoring their lung health.\nWith the Lung Health Score, you can gain a better understanding of your respiratory condition, track changes over time, and take proactive steps to maintain and improve your lung health.",
    ranges: [
      {
        point: 0,
        result: "Very Severe Risk",
        label: "You may be at risk of experiencing Lung Obstruction",
        category: "(FEV1/FVC < 70%, FEV1 < 30% predicted)",
        color: "#A20303",
        desc: "You may be at a very severe risk for Chronic Obstructive Pulmonary Disease (COPD), which can include chronic bronchitis, emphysema, or both. Please note that this is a predictive indication based on your Lung Health Assessment, not a definitive diagnosis. We strongly recommend consulting a doctor for further evaluation and an accurate diagnosis.",
      },
      {
        point: 40,
        result: "Severe Risk",
        label: "You may be at risk of experiencing Lung Obstruction",
        category: "(FEV1/FVC < 70%, 30% ≤ FEV1 < 50% predicted)",
        color: "#DD3923",
        desc: "You may be at a severe risk for Chronic Obstructive Pulmonary Disease (COPD), which can include chronic bronchitis, emphysema, or both. Please note that this is a predictive indication based on your Lung Health Assessment, not a definitive diagnosis. We strongly recommend consulting a doctor for further evaluation and an accurate diagnosis.",
      },
      {
        point: 50,
        result: "Moderate",
        label: "You may have moderate chances of experiencing Lung Obstruction",
        category: "(FEV1/FVC < 70%, 50% ≤ FEV1 < 80% predicted)",
        color: "#F18233",
        desc: "You may be at a moderate risk for Chronic Obstructive Pulmonary Disease (COPD), which can include chronic bronchitis, emphysema, or both. Please note that this is a predictive indication based on your Lung Health Assessment, not a definitive diagnosis. We strongly recommend consulting a doctor for further evaluation and an accurate diagnosis.",
      },
      {
        point: 60,
        result: "Mild",
        label: "You may have mild chances of experiencing Lung Obstruction",
        category: "(FEV1/FVC < 70%, FEV1 ≥ 80% predicted)",
        color: "#FAC02B",
        desc: "You may be at a mild risk for Chronic Obstructive Pulmonary Disease (COPD), which can include chronic bronchitis, emphysema, or both. Please note that this is a predictive indication based on your Lung Health Assessment, not a definitive diagnosis. We strongly recommend consulting a doctor for further evaluation and an accurate diagnosis.",
      },
      {
        point: 70,
        result: "Low",
        label: "The probability of experiencing Lung Obstruction is very Low.",
        category: "(FEV1/FVC ≥ 70%)",
        color: "#64BD40",
        desc: "No risk observed for Chronic Obstructive Pulmonary Disease (COPD), which can include chronic bronchitis, emphysema, or both. Please note that this is a predictive indication based on your Lung Health Assessment, not a definitive diagnosis. We strongly recommend consulting a doctor for further evaluation and an accurate diagnosis.",
      },
      {
        point: 100,
        result: "Low",
        label: "The probability of experiencing Lung Obstruction is very Low.",
        category: "(FEV1/FVC ≥ 70%)",
        color: "#64BD40",
        desc: "No risk observed for Chronic Obstructive Pulmonary Disease (COPD), which can include chronic bronchitis, emphysema, or both. Please note that this is a predictive indication based on your Lung Health Assessment, not a definitive diagnosis. We strongly recommend consulting a doctor for further evaluation and an accurate diagnosis.",
      },
    ],
  },
};
